import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScrollToTopService {
  private router = inject(Router);
  private window = inject<Window | undefined>('WINDOW' as any);
  private platformId = inject<Object>(PLATFORM_ID);


  checkScroll() {
    if (!isPlatformBrowser(this.platformId) || !this.window) return;

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const win = this.window;
      if (win) {
        win.scrollTo(0, 0);
      }
    });
  }
}